import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import authReducer from './authReducer';
import userReducer from './userReducer';
import fpzReducer from './fpzReducer';

const rootReducer = combineReducers({
  form: formReducer,
  authReducer,
  userReducer,
  fpzReducer,
});

export default rootReducer;
